class NavAccordion {
  constructor({ triggerSelector, itemSelector, panelSelector, singleOpen = false }) {
    this.triggers = document.querySelectorAll(triggerSelector);
    this.itemSelector = itemSelector;
    this.panelSelector = panelSelector;
    this.singleOpen = singleOpen;

    this.init();
    this.initObservers();
  }


    init() {
    this.triggers.forEach(trigger => {
        trigger.addEventListener("click", () => this.toggle(trigger));
    });
    }

  toggle(trigger) {
    const item = trigger.closest(this.itemSelector);
    const panel = item.querySelector(`:scope > ${this.panelSelector}`);
    const isOpen = item.classList.contains("is-open");

    if (this.singleOpen && !isOpen) {
      this.closeAll(item);
    }

    if (isOpen) {
      this.close(item, panel);
    } else {
      this.open(item, panel);
    }

    this.updateParentDatasets(panel);
  }

  open(item, panel) {
    panel.style.maxHeight = panel.scrollHeight + "px";
    item.classList.add("is-open");
    item.dataset.open = 'true';

   // this.openFirstChild(item, panel);
  }

  openFirstChild(item, panel) {
    const firstChildItem = panel.querySelector(".nav-sub-acc-item");
    if (!firstChildItem || firstChildItem.classList.contains("is-open")) return;

    const childPanel = firstChildItem.querySelector(":scope > .nav-sub-acc-panel");
    if (!childPanel) return;

    firstChildItem.classList.add("is-open");
    firstChildItem.dataset.open = 'true';
    childPanel.style.maxHeight = childPanel.scrollHeight + "px";
    panel.style.maxHeight = panel.scrollHeight + "px";
  }

  close(item, panel) {
    panel.style.maxHeight = panel.scrollHeight + "px";
    item.classList.remove("is-open");
    item.dataset.open = 'false';
    requestAnimationFrame(() => {
      panel.style.maxHeight = "0px";
    });
  }

  closeAll(currentItem) {
    document.querySelectorAll(this.itemSelector).forEach(item => {
      if (item === currentItem) return;

      const panel = item.querySelector(`:scope > ${this.panelSelector}`);
      if (!panel) return;

      panel.style.maxHeight = panel.scrollHeight + "px";
      item.classList.remove("is-open");
      item.dataset.open = 'false';
      requestAnimationFrame(() => {
        panel.style.maxHeight = "0px";
      });
    });
  }

  initObservers() {
    const panels = document.querySelectorAll(this.panelSelector);

    this.observer = new ResizeObserver(entries => {
      entries.forEach(entry => {
        const panel = entry.target;
        const item = panel.closest(this.itemSelector);

        if (!item || !item.classList.contains("is-open")) return;

        panel.style.transition = 'none';
        panel.style.maxHeight = panel.scrollHeight + "px";
        this.updateParents(panel, true);
        requestAnimationFrame(() => {
          panel.style.transition = '';
        });
      });
    });

    panels.forEach(panel => {
      this.observer.observe(panel);
    });
  }

  updateParents(element, suppressTransition) {
    let parent = element.parentElement;

    while (parent) {
      if (
        parent.classList &&
        (parent.classList.contains("nav-acc-item") || parent.classList.contains("nav-sub-acc-item"))
      ) {
        if (parent.classList.contains("is-open")) {
          const panel = parent.querySelector(
            ":scope > .nav-acc-panel, :scope > .nav-sub-acc-panel"
          );

          if (panel) {
            if (suppressTransition) panel.style.transition = 'none';
            panel.style.maxHeight = panel.scrollHeight + "px";
            if (suppressTransition) {
              requestAnimationFrame(() => {
                panel.style.transition = '';
              });
            }
          }
        }
      }

      parent = parent.parentElement;
    }
  }

  updateParentDatasets(element) {
    let parent = element.parentElement;

    while (parent) {
      if (
        parent.classList &&
        (parent.classList.contains("nav-acc-item") || parent.classList.contains("nav-sub-acc-item") || parent.classList.contains("menu-drawer__navigation"))
      ) {
        const isOpen = parent.classList.contains("is-open");
        const newOpen = isOpen ? 'true' : 'false';


        const parentDrawerContainer = parent.closest(".menu-drawer__navigation");
        if (parentDrawerContainer) {
          const containerOpen = parent.dataset.open === 'true' ? 'true' : 'false';
          if (parentDrawerContainer.dataset.open !== containerOpen) {
            parentDrawerContainer.dataset.open = containerOpen;
          }
        }
      }

      parent = parent.parentElement;
    }
  }
}


// INIT — arranca en cuanto los elementos existen en el DOM, sin esperar DOMContentLoaded
const initAccordions = () => {
  if (!document.querySelector('.nav-acc-trigger')) return false;

  new NavAccordion({
    triggerSelector: ".nav-acc-trigger",
    itemSelector: ".nav-acc-item",
    panelSelector: ".nav-acc-panel",
    singleOpen: true
  });

  new NavAccordion({
    triggerSelector: ".nav-sub-acc-trigger",
    itemSelector: ".nav-sub-acc-item",
    panelSelector: ".nav-sub-acc-panel",
    singleOpen: false,
    openFirst: true
  });

  return true;
};

if (!initAccordions()) {
  const observer = new MutationObserver(() => {
    if (initAccordions()) observer.disconnect();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
}